import React, { Component } from 'react';
import cn from 'classnames';
import AngleDown from 'react-icons/lib/fa/angle-down';
import styles from './style.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
// eslint-disable-next-line import/first
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const getVariants = (t) => ({
  intoYard: {
    param: 'intoYard',
    key: 'intoYard',
    text: t('constants.view_type.filter.intoYard'),
    event: 'Web_Filters_Into_Yard',
    chessEvent: 'Web_List_Filters_Into_Yard',
  },
  toMountains: {
    param: 'toMountains',
    key: 'toMountains',
    text: t('constants.view_type.filter.toMountains'),
    event: 'Web_Filters_To_Mountains',
    chessEvent: 'Web_List_Filters_To_Mountains',
  },
  onSea: {
    param: 'onSea',
    key: 'onSea',
    text: t('constants.view_type.filter.onSea'),
    event: 'Web_Filters_On_Sea',
    chessEvent: 'Web_List_Filters_On_Sea',
  },
  toPark: {
    param: 'toPark',
    key: 'toPark',
    text: t('constants.view_type.filter.toPark'),
    event: 'Web_Filters_To_Park',
    chessEvent: 'Web_List_Filters_To_Park',
  },
  toGarden: {
    param: 'toGarden',
    key: 'toGarden',
    text: t('constants.view_type.filter.toGarden'),
    event: 'Web_Filters_To_Garden',
    chessEvent: 'Web_List_Filters_To_Garden',
  },
  toForest: {
    param: 'toForest',
    key: 'toForest',
    text: t('constants.view_type.filter.toForest'),
    event: 'Web_Filters_To_Forest',
    chessEvent: 'Web_List_Filters_To_Forest',
  },
  onSocialObjects: {
    param: 'onSocialObjects',
    key: 'onSocialObjects',
    text: t('constants.view_type.filter.onSocialObjects'),
    event: 'Web_Filters_On_Social_Objects',
    chessEvent: 'Web_List_Filters_On_Social_Object',
  },
  panoramicView: {
    param: 'panoramicView',
    key: 'panoramicView',
    text: t('constants.view_type.filter.panoramicView'),
    event: 'Web_Filters_Panoramic_View',
    chessEvent: 'Web_List_Filters_Panoramic_View',
  },
});

const defaultViewTypes = {
  intoYard: false,
  toMountains: false,
  onSea: false,
  toPark: false,
  toGarden: false,
  toForest: false,
  onSocialObjects: false,
  panoramicView: false,
};

// ////////////////////////////

export const parseSearch = (search, t) => {
  const { view_type } = search;

  if (!view_type) {
    return { view_type: [] };
  }
  const keys = view_type.split(',');
  const variants = getVariants(t);
  return {
    view_type: Object.keys(variants).reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.param)) {
        prev.push(variant.key);
      }
      return prev;
    }, []),
  };
};

export const compileSearch = (data, t) => {
  const { view_type: keys } = data;
  if (!keys || !keys.length) {
    return { view_type: undefined };
  }
  const variants = getVariants(t);

  return {
    view_type:
      Object.keys(variants)
        .reduce((prev, cur) => {
          const variant = variants[cur];
          if (keys.includes(variant.key)) {
            prev.push(variant.param);
          }
          return prev;
        }, [])
        .join(',') || undefined,
  };
};

export const compileRequest = (data) => {
  const { view_type } = data;
  return { view_type: view_type.length ? view_type : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search, i18n.t));

export const subtext = (search, t) => {
  const { view_type: keys } = parseSearch(search);
  const variants = getVariants(t);
  return (
    Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.text);
        }
        return prev;
      }, [])
      .join(', ') || i18n.t('components.header.filtersBar.filters.viewTypes.notSelected')
  );
};

class ViewTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.calculateList();
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.calculateList();
  }

  calculateList = () => {
    if (!this.props.chessfilter) {
      return;
    }

    this.list = this.props.cells.reduce(
      (list, cell) => (cell.data.view_type ? list.add(cell.data.view_type) : list),
      new Set()
    );
  };

  handleClearClick(e) {
    e.stopPropagation();
    const { search, dropdownData, mode, profile, objectType, t } = this.props;
    const { view_type } = parseSearch(search, t);

    const data = { view_type: defaultViewTypes };
    const compiledSearch = compileSearch(data, t);

    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick(Object.keys(view_type));

    trackGA(
      gaEvent.filterClearButtonsClick({
        eventContent: 'eshchyo',
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  }

  handleCheckboxClick(key, add) {
    const {
      search,
      dropdownData,
      eventData,
      mode,
      objectType,
      profile,
      chessfilter,
      buildingData,
      t,
    } = this.props;
    const { view_type: keys } = parseSearch(search, t);
    const view_type = [...keys];
    const { id, name } = eventData;
    const variants = getVariants(t);

    const eventName = chessfilter ? 'buildingChessFilterCheckboxesClick' : 'filterCheckboxesClick';
    const variant = variants[Object.keys(variants).find((v) => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(
      gaEvent[eventName]({
        eventContent: [variantName, ` | ${isChecked}`],
        eventContext: mode,
        productType: objectType,
        productName: buildingData && buildingData.title,
        productID: buildingData && buildingData.id,
        user_id: profile.id,
      })
    );

    if (eventData) {
      if (id) {
        tracker.sendEvent(variants[key].chessEvent, { name, id });
      } else {
        tracker.sendVariantEvent({ variants, key, selected: add, eventData });
      }
    }

    if (!view_type.includes(key)) {
      view_type.push(key);
    } else {
      view_type.splice(view_type.indexOf(key), 1);
    }

    const data = { view_type };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);

    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    if (this.props.chessfilter && !this.list.has(key)) {
      return null;
    }

    const { search, additional, t } = this.props;
    const { view_type } = parseSearch(search, t);
    const variants = getVariants(t);

    const variant = variants[key];

    return (
      <Checkbox
        key={variant.key}
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={view_type.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  toggleExpand() {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  }

  getSelectedCount() {
    const { search, t } = this.props;
    const { view_type } = parseSearch(search, t);
    return view_type.length;
  }

  render() {
    const { className, additional, chessfilter, search, t } = this.props;
    const { view_type } = parseSearch(search, t);
    const isViewTypesDefined = !!view_type.length;
    const { isExpanded } = this.state;
    const selectedCount = this.getSelectedCount();

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        {chessfilter ? (
          <p className={styles.ChessFilterTitle}>
            {t('components.header.filtersBar.filters.viewTypes.chooseViewType')}
          </p>
        ) : (
          <div className={styles.Header} onClick={this.toggleExpand}>
            <span className={styles.Title}>
              {t('components.header.filtersBar.filters.viewTypes.title')}
              {selectedCount > 0 && ` (${selectedCount})`}
              <AngleDown className={cn(styles.Icon, { [styles.Active]: isExpanded })} />
            </span>
            {additional && isViewTypesDefined && (
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.viewTypes.clear')}
              </Button>
            )}
          </div>
        )}
        {chessfilter ? (
          <div
            className={cn(styles.Checkboxes, {
              [styles.CheckboxesInChess]: this.props.chessfilter,
            })}
          >
            {this.checkbox('intoYard')}
            {this.checkbox('onSea')}
            {this.checkbox('toGarden')}
            {this.checkbox('toMountains')}
            {this.checkbox('panoramicView')}
            {this.checkbox('onSocialObjects')}
            {this.checkbox('toForest')}
            {this.checkbox('toPark')}
          </div>
        ) : (
          isExpanded && (
            <div
              className={cn(styles.Checkboxes, {
                [styles.CheckboxesInChess]: this.props.chessfilter,
              })}
            >
              {this.checkbox('intoYard')}
              {this.checkbox('onSea')}
              {this.checkbox('toGarden')}
              {this.checkbox('toMountains')}
              {this.checkbox('panoramicView')}
              {this.checkbox('onSocialObjects')}
              {this.checkbox('toForest')}
              {this.checkbox('toPark')}
            </div>
          )
        )}
      </div>
    );
  }
}

export default withTranslation()(ViewTypes);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/ViewType/ViewType.jsx